import { render, staticRenderFns } from "./AccountForcedPasswordChange.vue?vue&type=template&id=5624feee&scoped=true"
import script from "./AccountForcedPasswordChange.vue?vue&type=script&lang=js"
export * from "./AccountForcedPasswordChange.vue?vue&type=script&lang=js"
import style0 from "./AccountForcedPasswordChange.vue?vue&type=style&index=0&id=5624feee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624feee",
  null
  
)

export default component.exports